<script>
    import SortableTable from '../SortableTable.svelte';
    import Library from '../../Models/LibraryORM';
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import parseFields from '../../Utilities/parseFields';
    import { onMount } from 'svelte';

    export let assessment;
    export let cancelAction;
    export let saveAction;

    let library_sortFields;
    let library_formFields;

    let library_items;
    let library_unsub;

    let extra_formFields;

    let selected_section;

    let library_sections = [];

    function loadSections(assessment) {
        library_sections = assessment.assessment_type_data.report_sections.filter((section) => section.section_type == "library");
        selected_section = library_sections[0];
    }

    function loadLibraryData(section) {
        if (library_unsub) {
            library_unsub();
            library_unsub = undefined;
        }

        if (section.extra_fields) {
            extra_formFields = parseFields(section.extra_fields, false).formFields;
        } else {
            extra_formFields = [];
        }

        let library_model = new Library(section.library_type);
        library_unsub = library_model.store.subscribe((lib) => {
            if (!lib) return;

            let fields = parseFields(lib.fields);

            library_sortFields = fields.sortFields;
            library_formFields = fields.formFields;

            library_items = lib.items.items;
        });
    }

    function addItem(item) {
        // clone selected section to prevent being overwritten while showing the form
        let cloned_selected_section = JSON.parse(JSON.stringify(selected_section));

        // create a copy of item;
        let cloned = JSON.parse(JSON.stringify(item.details));

        cloned.template_id = item.details._id;

        cloned._id = undefined;
        cloned._rev = undefined
        cloned.type = undefined;

        addFormModal({
            fields: [...library_formFields, ...extra_formFields],
            data: cloned
        }).then((formData) => {
            saveAction({
                item: formData,
                section: cloned_selected_section
            })
        }).catch(() => {null});
    }

    function addCustom() {
        // clone selected section to prevent being overwritten while showing the form
        let cloned_selected_section = JSON.parse(JSON.stringify(selected_section));

        addFormModal({
            fields: [...library_formFields, ...extra_formFields],
        }).then((formData) => {
            saveAction({
                item: formData,
                section: cloned_selected_section
            })
        }).catch(() => {null});
    }

    $: loadSections(assessment);
    $: loadLibraryData(selected_section);

    onMount(() => {
        return () => {
            if (library_unsub) {
                library_unsub();
            }
        }
    })
</script>


<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card is-fullwidth">
        <header class="modal-card-head">
            <p class="modal-card-title">Add Item</p>
            <button class="delete" aria-label="close" on:click={cancelAction}></button>
        </header>
        <section class="modal-card-body">
            <div class="field is-horizontal">
                <div class="field-label is-normal">
                    <span class="label">Library</span>
                </div>
                <div class="field-body">
                    <div class="field">
                        <div class="control select is-fullwidth">
                            <select bind:value={selected_section}>
                                {#each library_sections as section (section.section_id)}
                                    <option value={section}>{section.section_name}</option>
                                {/each}
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            {#if library_sortFields}
            <div>
                <SortableTable sortFields={library_sortFields} tableData={library_items} ORM="true">
                    <div slot="rowActions" let:row={item}>
                        <div class="button is-success" on:click={() => addItem(item)}>
                            Add Item
                        </div>
                    </div>
                    <div class="level-item" slot="headerActions">
                        <button class="button is-info" on:click={addCustom}>Add Custom</button>
                    </div>
                </SortableTable>
            </div>
            {/if}
        </section>
    </div>
</div>
